import { Branch } from '@/api/model/branch'

export class ProjectMortgageService  {
    constructor(
        public branches: Branch[],
    ) { }

    static fromData(data: any): ProjectMortgageService {
        if (data === null || data instanceof ProjectMortgageService) {
            return data
        }

        return new ProjectMortgageService(
            Object.values(data.branches || {}).map(entry => Branch.fromData(entry)),
        )
    }
}
